import Link from "next/link";
import React, { FC, useState } from "react";
import { useRouter } from "next/router";
import { menus } from "../constants";
import NavBar from "./NavBar";
import Sidebar from "./Sidebar";

const StaticContainer: FC<Props> = (props) => {
  const { children, title, category } = props;
  const [open, setOpen] = useState(false);
  const router = useRouter();

  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  return (
    <div className="static-container">
      <NavBar handleDrawerToggle={handleDrawerToggle} />
      <Sidebar open={open} handleDrawerToggle={handleDrawerToggle} />
      {title && (
        <div className="page-title">
          <h1>{title}</h1>
        </div>
      )}

      {menus(router)?.map(
        (menu) =>
          // find the correct category and the category has to contain children links
          menu.category === category &&
          menu.links && (
            <div className="tab-panel" key={menu.name}>
              {(menu.links as any[])?.map((link) => (
                <Link
                  href={link.href}
                  key={link.name}
                  // `cond && "active"` renders the string "false" as a class
                  // name on every inactive tab, which is why the live HTML
                  // carried `class="tab-panel-link false"`. Harmless to the
                  // browser, but it means any future `.false` rule would hit
                  // every non-current tab.
                  className={`tab-panel-link${
                    link.name === title ? " active" : ""
                  }`}
                >
                  {link.name}
                </Link>
              ))}
            </div>
          )
      )}

      <main id="main-content" className="wrap">
        {children}
      </main>
    </div>
  );
};

interface Props {
  title?: string;
  category?: string;
  children?: React.ReactNode;
}

export default StaticContainer;
